import citizen2D from './citizen2D.png';

export type Citizen2DProps = JSX.IntrinsicElements['img'];
export const Citizen2D = ({ className, ...props }: Citizen2DProps) => (
  <img src={citizen2D} alt="citizen2D" className={className} {...props} width={14} height={14} />
);
